import Translation from "./Translation";

const TRANSLATIONS_ES = {
  Translation,
};
export default TRANSLATIONS_ES;

